import { BodyTypes } from '../../LevelManager';
import { TrapAnimated } from '../../TrapAnimated';

export class TrapAnimatedTorch extends TrapAnimated {
  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y, 'skull-torch', 'animation', true);

    // this.setScale(0.35);
    this.zIndex = 300;
    this.preMultipliedAlpha = true;
  }

  public init() {
    if (!this.isInitialised) {
      this.injectMatter(this as unknown as Phaser.GameObjects.GameObject);
      this.isInitialised = true;
    }
  }

  public reset() {
    this.setAlpha(1);
    this.setScale(0.5);
    this.setVisible(true);
    this.setActive(true);

    // this.y += this.displayOriginY * this.scaleY * 0.5;
    // this.y += this.displayOriginY * this.scaleY;
    this.y += 120 * this.scaleY;
  }

  protected injectMatter(target: Phaser.GameObjects.GameObject) {
    // this.setSize(this.displayWidth - 20, this.displayHeight -20);

    let rect = this.scene.matter.bodies.rectangle(
      0 * this.scaleX,
      25 * this.scaleY,
      this.displayWidth - 140 * this.scaleX,
      this.displayHeight - 50 * this.scaleY,
      {
        label: BodyTypes.TouchTrap,
        isStatic: true,
        onCollideCallback: this.onCollision.bind(this)
      }
    );

    rect.position.x = 0;
    rect.position.y = this.displayOriginY * this.scaleY * 0.5;

    super.injectMatter(target, rect);
  }
}
